<script setup>
  import { useWebStore } from '~/store/web';
  import { isSiteActive } from '~/utils/siteNavigation';

  const store = useWebStore();
  const route = useRoute();
  const props = defineProps({
    text: String,
    link: String,
    // Dropdown szülő esetén az al-oldalak is a szülőt jelölik ki.
    hasChildren: { type: Boolean, default: false },
  });

  // A `chosenTab`-ot a view setupja állítja be, ami SSR alatt a NavBar
  // renderelése UTÁN fut: a szerveren még üres, a kliensen már kitöltött.
  // A Vue a class-eltérést hydration közben nem javítja ki (`check-only`),
  // ezért a kiemelés friss betöltésnél sosem jelent meg. Az útvonal a szerveren
  // és a kliensen is ugyanaz, ezért elsődlegesen abból származtatjuk az aktív
  // fület, és csak visszaesésként használjuk a `chosenTab`-ot.
  const activeTab = computed(() => {
    const prefix = '/' + store.chosenLang + '/';
    if (!route.path.startsWith(prefix)) return store.chosenTab;
    return route.path.slice(prefix.length).replace(/\/$/, '');
  });

  const isChosen = computed(() =>
    props.hasChildren
      ? isSiteActive({ url: props.link }, activeTab.value)
      : props.link === activeTab.value
  );
  const showImage = computed(() => activeTab.value !== undefined && isChosen.value);
</script>

<template>
  {{ chosenTab }}
  <div class="navBarItem" :class="{ chosen: isChosen}">
    <img src="/POLIOL_I_50x50.webp" v-if="showImage">
    <span class="">{{ text }}</span>
  </div>
</template>

<style scoped lang="scss">
.navBarItem{
  position: relative;
  font-family: Inter-Medium,sans-serif;
  text-align: center;
  display: flex;
  align-items: center;
  height: 100%;
  img{
    display: block;
    height: 1.3rem;
    margin-right: 6px;
  }
  &:hover{
    cursor: pointer;
  }
  &::after{
    content:'';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 5px;
    width: 100%;
    background-color: #FF8700;
    display: none;
  }
  &:hover::after{
    display: block;
  }
  &.chosen{
    font-weight: bold;
    img{
      display: block;
    }
    &::after{
      display: block;
    }
  }
}
</style>